import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var FileDocumentTemplateSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M15.924 2H5.778C4.798 2 4 2.816 4 3.818v16.364C4 21.185 4.797 22 5.778 22h12.444c.98 0 1.778-.816 1.778-1.818V6.169L15.924 2zm-5.702 16.364H7.556v-1.819h2.666v1.819zm0-2.728H7.556v-1.818h2.666v1.818zm0-2.727H7.556v-1.818h2.666v1.818zm6.222 5.455H12V11.09h4.444v7.273zm-1.777-10.91V2.91l4.444 4.546h-4.444z", fill: "currentColor" })] })));
};

export { FileDocumentTemplateSolidIcon };
//# sourceMappingURL=FileDocumentTemplateSolidIcon.js.map
